var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-radio"},_vm._l((_vm.items),function(item,itemIdx){return _c('div',{key:item.label,staticClass:"a-radio__item",class:{'a-radio__item--selected': item.value === _vm.value },on:{"click":function($event){return _vm.handleClick(itemIdx, item.value)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }